export default {
  tabs: {
    multiCurrency: "多幣種畫布",
    singleCurrency: "單幣種畫布",
    solana: "solana畫布",
  },
  buttons: {
    createCanvas: "新建畫布",
  },
  search: {
    canvasName: "請輸入畫布名稱",
    startDate: "開始日期",
    endDate: "結束日期",
    reset: "重置",
    query: "查詢",
    allCanvas: "所有畫布",
    updateTime: "更新時間",
  },
  sort: {
    createTimeDesc: "創建時間降序",
    createTimeAsc: "創建時間升序",
    updateTimeDesc: "更新時間降序",
    updateTimeAsc: "更新時間升序",
  },
  table: {
    total: "共計",
    dataCount: "條資料",
    emptyText: "暫無資料",
    columns: {
      index: "序號",
      canvasName: "畫布名稱",
      canvasDescription: "畫布描述",
      canvasType: "畫布類型",
      addressHash: "地址/雜湊",
      currency: "幣種",
      chain: "鏈",
      creator: "創建人",
      createTime: "創建時間",
      updateTime: "更新時間",
      actions: "操作",
    },
    actions: {
      edit: "修改",
      keySteps: "關鍵步驟",
      delete: "刪除",
    },
  },
  messages: {
    deleteConfirm: "此操作將永久刪除{canvasName}畫布, 是否確定?",
    deleteTitle: "提示",
    deleteSuccess: "刪除成功",
    deleteCancelled: "已取消刪除",
    confirmButton: "確定",
    cancelButton: "取消",
  },
};
